import React from "react";
import { Star } from "lucide-react";
import { motion } from "framer-motion";

export default function Testimonials({ testimonials }) {
  const list = (testimonials || []).filter((t) => t.published).sort((a, b) => (a.order || 0) - (b.order || 0));
  if (list.length === 0) return null;
  return (
    <section className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="text-xs tracking-[0.28em] uppercase text-slate-500">Voices</div>
          <h2 className="mt-3 font-display text-3xl sm:text-5xl leading-tight text-[#0B132B]">Success Starts With Preparation</h2>
        </div>
        <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {list.map((t, i) => (
            <motion.figure key={t.id}
                           initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                           transition={{ delay: i * 0.08 }}
                           className="rounded-2xl p-6 ring-1 ring-slate-100 bg-gradient-to-br from-slate-50 to-white shadow-soft">
              <div className="flex items-center gap-1">
                {Array.from({ length: t.rating || 5 }).map((_, k) => (<Star key={`${t.id}-star-${k}`} size={14} className="fill-[#0B132B] text-[#0B132B]" />))}
              </div>
              <blockquote className="mt-4 text-slate-700 text-[15px] leading-relaxed">"{t.quote}"</blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                {t.photo_url ? (
                  <img src={t.photo_url} alt={t.name} className="h-10 w-10 rounded-full object-cover" />
                ) : (
                  <div className="h-10 w-10 rounded-full bg-slate-200" />
                )}
                <div>
                  <div className="text-sm font-medium text-[#0B132B]">{t.name}</div>
                  <div className="text-xs text-slate-500">{t.program}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
